interface Date {
    isValidDate(): boolean;
}

Date.prototype.isValidDate = function (): boolean {
    const checkDate = new Date(this);
    const isValid = checkDate instanceof Date && !isNaN(checkDate.getTime());
    return isValid;
}